<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10" v-if="formData.qualityIssuesCode">
        <el-col :span="24">
          <div class="mb-1">
            <el-tag
              class="mt-1"
              size="mini"
              :type="
                formData.status === 'Y'
                  ? 'success'
                  : formData.status === 'N'
                  ? 'danger'
                  : 'primary'
              "
            >
              {{ formData.v_status || '--' }}
            </el-tag>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Update：{{ formData.modifyByName ? formData.modifyByName : '--' }}
              at
              {{ formData.modifyTime || '--' }}
            </span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_qualityIssuesGroup') || '问题组'"
            prop="qualityIssuesGroup"
          >
            <el-select
              v-model.trim="formData.qualityIssuesGroup"
              filterable
              allow-create
              default-first-option
              style="width: 100%"
              :placeholder="
                $l('tips_input_qualityIssuesGroup_placeholder') ||
                  '请选择或创建问题组'
              "
            >
              <el-option
                v-for="item in options"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_qualityIssuesTitle') || '问题标题'"
            prop="qualityIssuesTitle"
          >
            <el-input
              clearable
              v-model.trim="formData.qualityIssuesTitle"
              :placeholder="
                $l('tips_input_qualityIssuesTitle_placeholder') ||
                  '请输入问题标题'
              "
              size="small"
              maxlength="255"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    qualityIssuesCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    const issuesGroupValidator = (rule, value, callback) => {
      if (value && value.length > 50) {
        callback(
          new Error(
            this.$l('tips_input_qualityIssuesGroup_maxLength') ||
              '问题组名称不能超过 50 个字符'
          )
        )
      } else {
        callback() // 通过
      }
    }
    return {
      formData: {},
      options: [],

      rules: {
        qualityIssuesGroup: [
          {
            required: true,
            message:
              this.$l('tips_input_qualityIssuesGroup_placeholder') ||
              '请输入问题组',
            trigger: 'blur',
          },
          { validator: issuesGroupValidator, trigger: 'blur' }, // 长度校验
        ],
        qualityIssuesTitle: [
          {
            required: true,
            message:
              this.$l('tips_input_qualityIssuesTitle_placeholder') ||
              '请输入问题标题',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api
        .mrpQualityIssuesGroupApi({})
        .then((res) => {
          this.options = res.body.data
        })
        .catch(() => {})
      if (!this.qualityIssuesCode) return
      this.$api
        .mrpQualityIssuesDetailApi({
          qualityIssuesCode: this.qualityIssuesCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .mrpQualityIssuesSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
